import React from 'react';
import { setCurrentView } from 'core/utils';
import { OrderDetailViewStore } from 'modules/order/stores';
import { OrderDetailTemplate } from 'themes/modules/order/pages';

@setCurrentView(rootStore => new OrderDetailViewStore(rootStore), 'orderDetailViewStore')
class OrderDetail extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <OrderDetailTemplate {...this.props} />;
	}
}

export default OrderDetail;



// WEBPACK FOOTER //
// ./src/modules/order/pages/OrderDetail.jsx